import React from 'react';
import { GridTable } from '@components/common/grid';
import { formatWithDefault, formatCurrency } from '@common/utils';

const GridTableRpu = ({
  id = 'grid-policy-change-rpu',
  title,
  data,
  isCurrencyUsd,
  isFaceAmount,
}) => {
  const premiumColNames = isFaceAmount ? ['기 가입금액'] : [];
  const premiumColModels = isFaceAmount
    ? [
        {
          name: 'faceAmount',
          index: 'faceAmount',
          formatter: formatWithDefault(value =>
            formatCurrency(value, isCurrencyUsd),
          ),
        },
      ]
    : [];

  return (
    <GridTable
      id={id}
      title={title}
      sideTitle={isCurrencyUsd ? '(단위: 달러)' : '(단위: 원)'}
      options={{
        data,
        colNames: [
          ...premiumColNames,

          '감액완납 시 보험금액',
          '감액완납 시 변경차액',
        ],
        colModel: [
          ...premiumColModels,

          {
            name: 'reduPdupBnf',
            index: 'reduPdupBnf',
            formatter: formatWithDefault(value =>
              formatCurrency(value, isCurrencyUsd),
            ),
          },
          {
            name: 'reduPdupChgDfnnt',
            index: 'reduPdupChgDfnnt',
            formatter: formatWithDefault(value =>
              formatCurrency(value, isCurrencyUsd),
            ),
          },
        ],
      }}
    />
  );
};

export default GridTableRpu;
